import { Buffer } from "buffer";

// Must run before app imports that may reference Buffer at module init time.
if (!(globalThis as { Buffer?: typeof Buffer }).Buffer) {
  (globalThis as { Buffer?: typeof Buffer }).Buffer = Buffer;
}
